// Whether a seller should see the UK flow (£ currency, "Sort code", UK bank fields)
// vs the US flow ($, "Routing number", account type + mailing address, USD ID-badge
// pricing). Single source of truth — previously this check was inlined in ~8 places
// and had already drifted (some read only `country`, some `country || loginLocation`).
//
// Resolution PREFERS `ipCountry` — the seller's REAL browser IP, captured from the
// create-session response at Step 1 (Step01Welcome) and stored on sessionData. The
// declared/login country fields can be flat wrong: a genuine US seller (Chicago,
// +1 312, US IP) can arrive with `country` AND `loginLocationCountry` = 'GB' when the
// Step-4 country dropdown defaults/mis-fills. Trusting those put such sellers into the
// UK payment form (no US routing-number / account-type / mailing-address fields) and
// showed them £ — they literally couldn't enter their US bank details. (2026-07-07 fix.)
//
// ipCountry FIRST is deliberate and differs from the Step-2 GHL lead router (which
// puts login_location_country first) because at the payment step login_location_country
// is already SET — and possibly wrong — so it must NOT win over the real IP.
//
// Falls back to loginLocationCountry then country when ipCountry is absent (~2% of
// sessions), preserving prior behavior. Genuine UK sellers have ipCountry='GB' so they
// always resolve UK — no regression. A fully-ambiguous session (all three null) resolves
// NOT-UK → $ (the historical default when both country signals were null).
//
// Migration 259's assign_messenger_profile resolves the seller's agent pool with
// this same rule in SQL: upper(COALESCE(NULLIF(ip_country,''), NULLIF(login_location_
// country,''), NULLIF(country,''))) IN ('GB','UK'). Keep the two identical: `||`
// skips '' like NULLIF, and the value is upper-cased like upper(). ipCountry must
// survive a reload for this to hold (App.jsx hydration restores it).
export function isUKSeller(sessionData) {
  const c =
    sessionData?.ipCountry ||
    sessionData?.loginLocationCountry ||
    sessionData?.country;
  const cc = c ? String(c).toUpperCase() : c;
  return cc === 'GB' || cc === 'UK';
}
